import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Dialog, EmptyState, Loading, StatCard } from "../../components/VB";
import { toast } from "sonner";
import { PiggyBank, RefreshCw, Wallet } from "lucide-react";
import { PaymentInfoGrid } from "./Dashboard";
import MutasiTable from "../../components/MutasiTable";

const fmtUSD = (n) => "$ " + (parseFloat(n || 0)).toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
const fmtIDR = (n) => "Rp " + (parseFloat(n || 0)).toLocaleString("id-ID", { maximumFractionDigits: 0 });
const fmtCur = (n, cur) => (cur === "IDR" ? fmtIDR(n) : fmtUSD(n));

// Tabungan Kepala Group — read-only. Kredit/Debit hanya dilakukan admin di menu Arus Kas.
export default function ClientTabungan() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  // Dialog "Alamat Transfer" — daftar rekening/wallet PT Fivehoster yang sama dengan
  // "Alamat Pembayaran" di dashboard project (GET /client/payment-info), dimuat saat dibuka.
  const [showTransfer, setShowTransfer] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const openTransfer = async () => {
    setShowTransfer(true);
    if (paymentInfo) return;
    try {
      const res = await api.get("/client/payment-info");
      setPaymentInfo(res.data || []);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setPaymentInfo([]); }
  };

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/client/tabungan");
      setData(res.data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  if (loading && !data) return <Loading message="Memuat tabungan..." />;
  if (!data) return <EmptyState message="Tabungan belum tersedia" />;

  const { rekening: rk, mutasi } = data;
  const totalKredit = mutasi.filter((m) => m.arah === "Masuk").reduce((a, m) => a + parseFloat(m.nominal || 0), 0);
  const totalDebit = mutasi.filter((m) => m.arah !== "Masuk").reduce((a, m) => a + parseFloat(m.nominal || 0), 0);

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <Window
        title={<><PiggyBank className="w-4 h-4 inline mr-1" />{rk.nama}</>}
        actions={
          <div style={{ display: "flex", gap: 6 }}>
            <button className="vb-btn" style={{ padding: "3px 10px", display: "flex", alignItems: "center", gap: 4 }} onClick={openTransfer} data-testid="tab-open-transfer">
              <Wallet className="w-3 h-3" />Alamat Transfer
            </button>
            <button className="vb-btn" style={{ padding: "3px 8px" }} onClick={load} title="Muat ulang"><RefreshCw className="w-3 h-3" /></button>
          </div>
        }
      >
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 8 }}>
          <StatCard label="Saldo Tabungan" value={fmtCur(rk.saldo, rk.currency)} testId="tab-saldo" valueColor={parseFloat(rk.saldo || 0) < 0 ? "#d8000c" : undefined} />
          <StatCard label="Total Kredit" value={fmtCur(totalKredit, rk.currency)} testId="tab-kredit" />
          <StatCard label="Total Debit" value={fmtCur(totalDebit, rk.currency)} testId="tab-debit" />
        </div>
        <div style={{ background: "#FFFFE1", border: "1px solid #828790", padding: 8, fontSize: 12, marginTop: 10 }}>
          Saldo tabungan dikelola oleh admin PT Fivehoster. Hubungi admin untuk penambahan atau penarikan saldo.
        </div>
      </Window>

      <Dialog
        open={showTransfer}
        onClose={() => setShowTransfer(false)}
        title={<><Wallet className="w-4 h-4 inline mr-1" />Alamat Transfer</>}
        width={720}
        footer={<button className="vb-btn" onClick={() => setShowTransfer(false)}>Tutup</button>}
      >
        {paymentInfo === null ? <Loading message="Memuat alamat transfer..." /> : paymentInfo.length === 0 ? (
          <EmptyState message="Admin belum mengatur rekening / wallet pembayaran." />
        ) : (
          <PaymentInfoGrid paymentInfo={paymentInfo} />
        )}
      </Dialog>

      <Window title="Riwayat Mutasi">
        <MutasiTable items={mutasi} fmt={(n) => fmtCur(n, rk.currency)} mode="client" />
      </Window>
    </div>
  );
}
